import { render, staticRenderFns } from "./ListRecapitulation.vue?vue&type=template&id=473e9191&"
import script from "./ListRecapitulation.vue?vue&type=script&lang=js&"
export * from "./ListRecapitulation.vue?vue&type=script&lang=js&"
import style0 from "./ListRecapitulation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports